<template>
    <div v-if="visible" class="loader-line"></div>
</template>

<script setup>
import { ref, defineExpose } from 'vue';

const visible = ref(false)

defineExpose({
  visible,
});

</script>

<style scoped>

.loader-line {
            width: 100%;
            height: 3px;
            position: fixed;
            top: 0;
            left: 0;
            overflow: hidden;            
            background: rgb(255,143,0);
            background: radial-gradient(circle, rgba(255,143,0,1) 0%, rgba(255,190,0,1) 100%);
            margin: 0px auto;
            border-bottom: 1px solid #333;
        }

        .loader-line:before {
            content: "";
            position: absolute;
            left: 0%;
            height: 3px;
            width: 40%;
            background: rgba(255,143,0,1);
            background: radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(255,143,0,1) 100%);
            -webkit-animation: lineAnim 1s linear infinite;
            -moz-animation: lineAnim 1s linear infinite;
            animation: lineAnim 1s linear infinite;
        }

        @keyframes lineAnim {
            0% {
                left: -40%;
            }
            50% {
                left: 20%;
                width: 80%;
            }
            100% {
                left: 100%;
                width: 100%;
            }
        }

</style>

<i18n>

</i18n>
